import { fetchAuthSession } from "aws-amplify/auth";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";

export async function getUserRelayAuthState() {
  const session = await fetchAuthSession();
  const storedTokens =
    await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();
  const idToken = session.tokens?.idToken;
  const accessToken = session.tokens?.accessToken;
  const refreshToken = storedTokens?.refreshToken;

  if (!idToken || !accessToken || !refreshToken) {
    throw new Error("The user session is incomplete.");
  }

  return {
    idToken: idToken.toString(),
    accessToken: accessToken.toString(),
    refreshToken,
  };
}

export async function clearUserBrowserSession() {
  // Local cleanup only. signOut can revoke a refresh token already delivered
  // to another client, and Hosted UI logout can navigate away from the relay.
  await cognitoUserPoolsTokenProvider.authTokenStore.clearTokens();
}

export async function waitForUserRelayAuthState({
  timeoutMs = 10_000,
  pollIntervalMs = 100,
} = {}) {
  const deadline = Date.now() + timeoutMs;
  let lastError;

  do {
    try {
      return await getUserRelayAuthState();
    } catch (error) {
      lastError = error;
    }
    await new Promise((resolve) => window.setTimeout(resolve, pollIntervalMs));
  } while (Date.now() < deadline);

  throw lastError;
}
